var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPropisi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "30px",
    width: "30px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297.001 297.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M262.521,48.866h-38.82v-38.82C223.701,4.498,219.203,0,213.656,0H34.479c-5.548,0-10.046,4.498-10.046,10.046v244.331 c0,5.548,4.498,10.046,10.046,10.046h38.82v22.532c0,5.548,4.498,10.046,10.046,10.046h179.176 c5.548,0,10.046-4.498,10.046-10.046V58.912C272.567,53.364,268.069,48.866,262.521,48.866z M76.24,106.433 c-1.884,1.885-2.942,4.439-2.942,7.104v130.794H44.525V20.092h159.085v28.774h-65.64c-2.665,0-5.219,1.059-7.104,2.942 L76.24,106.433z M127.925,83.165v20.325l-20.326,0.001L127.925,83.165z M252.476,276.908L252.476,276.908H93.391V123.583 l44.58-0.001c5.549,0,10.046-4.498,10.046-10.046V68.958h104.459V276.908z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropisi);
export default __webpack_public_path__ + "static/media/Propisi.aab8ff3fec4c2e53335564eee9dfec94.svg";
export { ForwardRef as ReactComponent };